import { foulsOf } from '@/utils/playerStats'

const STAT_KEYS = [
    'points',
    'rebounds',
    'assists',
    'assistPoints',
    'secondChancePoints',
    'pointsOffTurnovers',
    'steals',
    'turnovers',
    'blockedShots',
    'twoPointsMade',
    'twoPointAttempts',
    'threePointsMade',
    'threePointAttempts',
    'freeThrowsMade',
    'freeThrowAttempts',
    'offensiveRebounds',
    'defensiveRebounds',
    'personalFouls',
    // every foul: personal, technical and unsportsmanlike
    'fouls',
    'pir',
    'playTimeInSecs'
]

export function getCummulativeStats(player) {
    const stats = STAT_KEYS.reduce((acc, key) => {
        acc[key] = 0
        return acc
    }, {})

    const playerStats = Array.isArray(player?.stats) ? player.stats : []
    playerStats.forEach(element => {
        STAT_KEYS.forEach(key => {
            stats[key] += key === 'fouls' ? foulsOf(element) : (element[key] || 0)
        })
    })

    return stats
}

export function getAverageStats(player) {
    const stats = getCummulativeStats(player)
    const playerStatsLength = Array.isArray(player?.stats) ? player.stats.length : 0

    STAT_KEYS.forEach(key => {
        stats[key] = playerStatsLength ? stats[key] / playerStatsLength : 0
    })

    return stats
}

export function calculateTeamStats(team) {
    const players = Array.isArray(team?.players) ? team.players : []
    players.forEach(player => {
        player.avg = getAverageStats(player)
        player.cum = getCummulativeStats(player)
    })
    return team
}
